<template>
  <v-dialog v-model="dialogComputed" max-width="800px" scrollable>
    <v-card>
      <v-card-title class="primary white--text py-2">
        {{ $t('ELE0018') }}
        <v-spacer />
        <Btn icon="mdi-close" @click="close" depressed iconProp color="white" />
      </v-card-title>
      <v-card-text v-if="isItemSet">
        <v-container fluid class="px-0">
          <v-row>
            <v-col cols="3">
              <SelectSingleInput
                :label="$t('ELE0283')"
                :items="partRevs"
                itemText="text"
                itemValue="value"
                :clearable="false"
                v-model="selectPartRev"
                @change="getPartInfo(selectPartRev)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <TextFieldRef :label="$t('ELE0031')" :value="partInfo.partCd" />
            </v-col>
            <v-col>
              <TextFieldRef class="pr-auto" :label="$t('ELE0032')" :value="partInfo.partName" />
            </v-col>
          </v-row>
          <v-row v-if="isShownMold">
            <v-col>
              <Checkbox :label="$t('ELE0495')" :value="partInfo.isManagedMold" disabled />
            </v-col>
            <v-col>
              <TextFieldRef :label="$t('ELE0051')" :value="partInfo.moldNo" disabled />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <TextFieldRef :label="$t('ELE0224')" :value="partInfo.model" />
            </v-col>
            <v-col>
              <PartCatInput :value="partInfo.partCatCd" validOnly disabled />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <PartGroupInput :value="partInfo.partGroupCd" disabled />
            </v-col>
            <v-col>
              <MeasuringInstrumentInput :value="partInfo.measInstCd" disabled />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <PartInspTimingInput :value="partInfo.partInspTimingCd" disabled />
            </v-col>
            <v-col>
              <PartInspQtyStdInput
                :value="partInfo.inspQtyStdCd"
                :partInspTimingCd="partInfo.partInspTimingCd"
                disabled
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col></v-col>
            <v-col>
              <TextFieldRef :label="$t('ELE0285')" :value="partInfo.inspBasicQty" right />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <InspFilteringInput :label="$t('ELE0289')" :value="partInfo.oqcInspFiltering" disabled />
            </v-col>
            <v-col>
              <Btn class="mt-1" :label="$t('ELE0288')" @click="onClickOqcEditCharacteristic" :disabled="!characItem" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <InspFilteringInput :label="$t('ELE0290')" :value="partInfo.iqcInspFiltering" disabled />
            </v-col>
            <v-col>
              <Btn class="mt-1" :label="$t('ELE0288')" @click="onClickIqcEditCharacteristic" :disabled="!characItem" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <AqlRateInput :label="$t('ELE0338')" v-model="partInfo.oqcAqlRateCd" disabled />
            </v-col>
            <v-col>
              <AqlRateInput :label="$t('ELE0339')" v-model="partInfo.iqcAqlRateCd" disabled />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <DefectGroupInput v-model="partInfo.defectGroupCd" disabled />
            </v-col>
            <v-col> <CompanyMultipleInput :label="$t('ELE0134')" :value="partInfo.supplierCds" disabled /> </v-col>
          </v-row>
          <v-row>
            <v-col>
              <BtnChooseValid :value="partInfo.isValid" disabled />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <UserInput :value="partInfo.itemUpdatedBy" :label="$t('ELE0039')" disabled />
            </v-col>
            <v-col>
              <TextFieldRef :value="partInfo.itemUpdatedAt" :label="$t('ELE0030')" />
            </v-col>
          </v-row>
        </v-container>
        <v-divider />
        <v-row>
          <v-col class="mt-2 d-flex flex-row justify-end">
            <BtnClose @click="close" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <EditCharacteristicDialog
      v-if="editInspFilteringDialog"
      isInquiry
      :dialog.sync="editInspFilteringDialog"
      :editCharacItem="characItem"
      :selectInspFiltering="selectInspFiltering"
    />
  </v-dialog>
</template>

<script>
import { API } from '@/plugins/api'
import { OqcIqcCd } from '@/enum'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'
import Checkbox from '@/components/atoms/base/checkbox/Checkbox'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import Btn from '@/components/atoms/base/button/Btn'
import BtnChooseValid from '@/components/atoms/button/BtnChooseValid'
import BtnClose from '@/components/atoms/button/BtnClose'
import CompanyMultipleInput from '@/components/atoms/select/CompanyMultipleInput'
import PartCatInput from '@/components/atoms/select/PartCatInput'
import PartGroupInput from '@/components/atoms/select/PartGroupInput'
import MeasuringInstrumentInput from '@/components/atoms/select/MeasuringInstrumentInput'
import AqlRateInput from '@/components/atoms/select/AqlRateInput'
import DefectGroupInput from '@/components/atoms/select/DefectGroupInput'
import UserInput from '@/components/atoms/select/UserInput'
import PartInspTimingInput from '@/components/atoms/select/PartInspTimingInput'
import PartInspQtyStdInput from '@/components/atoms/select/PartInspQtyStdInput'
import EditCharacteristicDialog from '@/components/organisms/master/dialog/EditCharacteristicDialog'
import InspFilteringInput from '@/components/atoms/select/InspFilteringInput'

export default {
  name: 'PartInquiryDialog',
  mixins: [APIUtils, Message, Loading, DateUtils],

  components: {
    TextFieldRef,
    SelectSingleInput,
    Btn,
    BtnClose,
    BtnChooseValid,
    CompanyMultipleInput,
    PartCatInput,
    PartGroupInput,
    Checkbox,
    MeasuringInstrumentInput,
    AqlRateInput,
    DefectGroupInput,
    UserInput,
    PartInspTimingInput,
    PartInspQtyStdInput,
    EditCharacteristicDialog,
    InspFilteringInput,
  },

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    partCd: {
      type: String,
      required: true,
    },
    partRev: {
      type: Number,
      required: true,
    },
    isShownMold: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isItemSet: false,
      editInspFilteringDialog: false,
      supplierCds: [],
      partRevs: [],
      selectPartRev: null,
      characItem: null,
      selectInspFiltering: null,
      partInfo: {
        partCd: '',
        partName: '',
        isManagedMold: false,
        moldNo: '',
        model: '',
        partCatCd: '',
        partGroupCd: '',
        measInstCd: '',
        partInspTimingCd: '',
        inspQtyStdCd: '',
        inspBasicQty: '',
        iqcAqlRateCd: '',
        oqcAqlRateCd: '',
        defectGroupCd: '',
        isValid: '',
        supplierCds: [],
        oqcInspFiltering: '',
        iqcInspFiltering: '',
        itemUpdatedBy: '',
        itemUpdatedAt: '',
      },
    }
  },

  computed: {
    dialogComputed: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
  },

  watch: {
    dialog() {
      if (this.dialog) {
        this.init()
      }
    },
  },

  methods: {
    close() {
      this.dialogComputed = false
      this.isItemSet = false
    },
    async init() {
      this.getInspFilteringCd()
      this.getInspCharFiltering()
      this.getSupplierCds()
      this.partRevs = []
      for (let i = this.partRev; i >= 1; i--) {
        this.partRevs.push({ text: i, value: i })
      }
      await setImmediate(() => (this.selectPartRev = this.partRev))
      this.getPartInfo(this.partRev)
      this.getAqlRate(this.partRev)
      this.isItemSet = true
    },
    async getSupplierCds() {
      this.partInfo.supplierCds = []
      try {
        if (this.partCd == '') {
          return
        }
        const body = {
          partCd: this.partCd,
          validOnly: true,
        }
        const elements = await API.get('/master/supplierParts', body)
        elements.forEach((element) => {
          this.partInfo.supplierCds.push(element['supplierCd'])
        })
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0134') })))
      }
    },
    async getPartInfo(partRev) {
      try {
        if (this.partCd == '') {
          return
        }
        const body = {
          partRev: partRev,
        }
        const elements = await API.get(`/master/parts/${this.partCd}`, body)
        await this.setPartInfo(elements)
        await this.getInspFilteringCd(partRev)
        await this.getAqlRate(partRev)
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0059') })))
      }
    },
    setPartInfo(item) {
      this.partInfo.partCd = item['partCd']
      this.partInfo.partName = item['partName']
      this.partInfo.isManagedMold = item['isManagedMold']
      this.partInfo.moldNo = item['moldNo']
      this.partInfo.model = item['model']
      this.partInfo.partCatCd = item['partCatCd']
      this.partInfo.partGroupCd = item['partGroupCd']
      this.partInfo.measInstCd = item['measInstCd']
      this.partInfo.partInspTimingCd = item['partInspTimingCd']
      this.partInfo.inspQtyStdCd = item['inspQtyStdCd']
      this.partInfo.inspBasicQty = !item['inspBasicQty'] ? '' : item['inspBasicQty']
      this.partInfo.defectGroupCd = item['defectGroupCd']
      this.partInfo.isValid = item['isValid']
      this.partInfo.itemUpdatedBy = item['itemUpdatedBy']
      this.partInfo.itemUpdatedAt = this.toLocalTime(item['itemUpdatedAt'])
    },
    async getInspFilteringCd(partRev) {
      this.partInfo.oqcInspFiltering = ''
      this.partInfo.iqcInspFiltering = ''
      try {
        const body = {
          partCd: this.partCd,
          partRev: partRev,
        }
        const elements = await API.get('/master/partInspFilterings', body)
        if (elements.length !== 2) {
          return
        }
        elements.forEach((element) => {
          if (element['inspTimingCd'] === OqcIqcCd.OQC) {
            this.partInfo.oqcInspFiltering = element['inspFilteringGroupCd']
          } else {
            this.partInfo.iqcInspFiltering = element['inspFilteringGroupCd']
          }
        })
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0143') })))
      }
    },
    async onClickOqcEditCharacteristic() {
      this.selectInspFiltering = await this.getInspFilteringMap(this.partInfo.oqcInspFiltering)
      this.editInspFilteringDialog = true
    },
    async onClickIqcEditCharacteristic() {
      this.selectInspFiltering = await this.getInspFilteringMap(this.partInfo.iqcInspFiltering)
      this.editInspFilteringDialog = true
    },
    async getInspFilteringMap(filteringGroupCd) {
      this.startLoading()
      try {
        if (filteringGroupCd === '') {
          return
        }
        const params = {
          filteringGroupCd: filteringGroupCd,
        }
        return await API.get(`/master/inspFilterings/group`, params)
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0143') })))
      } finally {
        this.stopLoading()
      }
    },
    async getInspCharFiltering() {
      try {
        this.startLoading()
        const params = {
          partCd: this.partCd,
        }
        this.characItem = await API.get('/master/inspCharFilterings', params)
        this.convertInspFiltering()
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0143') })))
      } finally {
        this.stopLoading()
      }
    },
    async getAqlRate(partRev) {
      this.partInfo.oqcAqlRateCd = ''
      this.partInfo.iqcAqlRateCd = ''
      try {
        if (this.isAdd) {
          return
        }
        const body = {
          partCd: this.partCd,
          partRev: partRev,
        }
        const elements = await API.get('/master/partAqlRates', body)
        if (elements.length !== 2) {
          return
        }
        elements.forEach((element) => {
          if (element['inspTimingCd'] === OqcIqcCd.OQC) {
            this.partInfo.oqcAqlRateCd = element['aqlRateCd']
          } else {
            this.partInfo.iqcAqlRateCd = element['aqlRateCd']
          }
        })
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0143') })))
      }
    },
    convertInspFiltering() {
      for (let i = 0; i < this.characItem.bodies.length; i++) {
        const charac = this.characItem.bodies[i]
        for (let j = 0; j <= this.characItem.filteringHeader.length - 1; j++) {
          let obj = charac.filtering.find(
            (item) => item.filteringCd == this.characItem.filteringHeader[j].inspFilteringCd,
          )
          if (obj) {
            charac[`${this.characItem.filteringHeader[j].inspFilteringCd}`] = obj.isInsp
          } else {
            charac[`${this.characItem.filteringHeader[j].inspFilteringCd}`] = false
            charac.filtering.push({
              filteringCd: this.characItem.filteringHeader[j].inspFilteringCd,
              isInsp: false,
            })
          }
        }
      }
    },
  },

  async mounted() {
    this.init()
  },
}
</script>
